<template>
    <div v-if="showMobileDepartmentsMenu">
        <div
            class="remoteMenuBlocker"
            @click="toggleMobileDepartmentsMenu"
        />
        <aside class="mobileDepartmentMenu">
            <header>
                <h2 class="mobileDepartmentMenu__heading">
                    Departments
                </h2>
                <div
                    class="mobileDepartmentMenu__close"
                    @click="toggleMobileDepartmentsMenu"
                >
                    <i class="fal fa-times" />
                </div>
                <!--/.mobileDepartmentMenu__close-->
            </header>
            <nav class="mobileDepartmentMenu__nav">
                <slot />
            </nav>
        </aside>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'MobileDepartmentMenu',
    computed: {
        ...mapState(['showMobileDepartmentsMenu']),
    },
    methods: {
        ...mapActions(['toggleMobileDepartmentsMenu']),
    },
};
</script>
